import { render, staticRenderFns } from "./NbQuoteShipmentInformation.vue?vue&type=template&id=72ef4cd9&"
import script from "./NbQuoteShipmentInformation.vue?vue&type=script&lang=js&"
export * from "./NbQuoteShipmentInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports